export const MAKER_DEPRECATION_SUPPORT_URL =
  'https://support.code.org/hc/en-us/articles/11304760762125';

export const MAKER_TOOLKIT = 'maker-toolkit';

export const DOWNLOAD_PREFIX = 'https://downloads.code.org/maker/';

export const MIN_CHROME_VERSION = 90; // Minimum version needed to be able to use WebSerial API.
// Actual minimum is 89, but out tech support articles state that users should be on v90 or above.
// https://developer.mozilla.org/en-US/docs/Web/API/Web_Serial_API#browser_compatibility
